// End-truncation ("Microsoft Investment Plan doc…") is useless for names that
// share a long common prefix and only differ near the end — every card reads
// identically. Truncating the middle keeps both the distinguishing start and
// end visible: "Microsoft Investment…Plan doc 3".
export function truncateMiddle(text, maxLength = 26) {
  if (!text || text.length <= maxLength) return text ?? "";
  const keepEnd = Math.floor(maxLength * 0.4);
  const keepStart = maxLength - keepEnd - 1; // -1 for the ellipsis character
  return `${text.slice(0, keepStart)}…${text.slice(text.length - keepEnd)}`;
}

// Project and document names are stored as varchar(255) — anything longer is
// rejected by the backend with a raw SQL error, so cap it at the input.
export const MAX_NAME_LENGTH = 255;
